// import React from "react";

// const StepsSection = () => {
//   return (
//     <section className='step py-80'>
//       <div className='position-relative z-1'>
//         <img
//           src='assets/images/shape/curve-line-shape.png'
//           alt=''
//           className='position-absolute top-0 inset-inline-end-0 z-n1 me-60 d-lg-block d-none'
//         />
//         <div className='container container-lg'>
//           <div className='row gy-4'>
//             <div className='col-lg-6'>
//               <div className='step-content'>
//                 <div className='section-heading ms-auto text-end'>
//                   <h5 className=''>Over $200k in potential benefits</h5>
//                   <span className='text-gray-600'>
//                     Ready to sell? Launch your brand today with a powerful for
//                     new sellers and over $200k in potential benefits
//                   </span>
//                 </div>
//                 <div className='d-flex flex-column align-items-end gap-56'>
//                   <div className='d-flex align-items-center gap-32'>
//                     <div className='text-end'>
//                       <h5 className='mb-8'>Step 01</h5>
//                       <p className='text-gray-600'>
//                         Create an account on our website. It is fast and free.
//                       </p>
//                     </div>

//                     <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
//                       <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
//                         01
//                       </h6>
//                     </div>

//                   </div>
//                   <div className='d-flex align-items-center gap-32'>
//                     <div className='text-end'>
//                       <h5 className='mb-8'>Step 02</h5>
//                       <p className='text-gray-600'>
//                         {" "}
//                         Upload your products and the display in your shop.
//                       </p>
//                     </div>
//                     <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
//                       <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
//                         02
//                       </h6>
//                     </div>
//                   </div>
//                   <div className='d-flex align-items-center gap-32'>
//                     <div className='text-end'>
//                       <h5 className='mb-8'>Step 03</h5>
//                       <p className='text-gray-600'>
//                         We'll verify your account and then you can start
//                         selling!
//                       </p>
//                     </div>
//                     <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
//                       <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
//                         03
//                       </h6>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className='col-lg-6'>
//               <div className='text-center'>
//                 <img src='assets/images/thumbs/steps.png' alt='' />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default StepsSection;

import React from "react";

const StepsSection = () => {
  return (
    <section className="step py-80">
      <div className="position-relative z-1">
        <img
          src="assets/images/shape/curve-line-shape.png"
          alt=""
          className="position-absolute top-0 inset-inline-end-0 z-n1 me-60 d-lg-block d-none"
        />

        <div className="container container-lg">
          <div className="row gy-4 align-items-center">

            {/* IMAGE FIRST IN MOBILE */}
            <div className="col-lg-6 order-lg-2 order-1">
              <div className="text-center mb-4 mb-lg-0">
                <img
                  src="assets/images/logo/becomeSeller.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>

            {/* TEXT & STEPS */}
            <div className="col-lg-6 order-lg-1 order-2">
              <div className="step-content">

                {/* Heading */}
                <div className="section-heading text-lg-end text-center mb-4">
                  <h5>Over $200k in potential benefits</h5>
                  <span className="text-gray-600 d-block mt-2">
                    Ready to sell? Launch your brand today with a powerful for
                    new sellers and over $200k in potential benefits
                  </span>
                </div>

                {/* STEPS LIST */}
                <div className="d-flex flex-column gap-40 gap-lg-56 align-items-lg-end align-items-center">

                  {/* Step 01 */}
                  <div className="d-flex align-items-center gap-16 gap-lg-32 flex-row-reverse flex-lg-row text-center text-lg-end">
                    <div>
                      <h5 className="mb-8">Step 01</h5>
                      <p className="text-gray-600 mb-0">
                        Create an account on our website. It is fast and free.
                      </p>
                    </div>
                     <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
                       <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                         01
                       </h6>
                     </div>

                  </div>

                  {/* Step 02 */}
                  <div className="d-flex align-items-center gap-16 gap-lg-32 flex-row-reverse flex-lg-row text-center text-lg-end">
                    <div>
                      <h5 className="mb-8">Step 02</h5>
                      <p className="text-gray-600 mb-0">
                        Upload your products and display them in your shop.
                      </p>
                    </div>

                      <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
                         <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                           02
                         </h6>
                       </div>
                  </div>

                  {/* Step 03 */}
                  <div className="d-flex align-items-center gap-16 gap-lg-32 flex-row-reverse flex-lg-row text-center text-lg-end">
                    <div>
                      <h5 className="mb-8">Step 03</h5>
                      <p className="text-gray-600 mb-0">
                        We'll verify your account and then you can start selling!
                      </p>
                    </div>

                  <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
                         <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                           03
                         </h6>
                       </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection;
